import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WelcomeService {
  private openWelcome: boolean = false;

  setMustOpenWelcome(value: boolean) {
    this.openWelcome = value;
  }

  canOpenWelcome(): boolean {
    return this.openWelcome;
  }

  reset() {
    this.openWelcome = false;
  }
}